import React from 'react';
import { Modal } from 'antd';
import { scrollTriggerIntoView } from '../../util/modalUtils';
import { useModalWidth } from '../../hooks/useModalWidth';

// Props: visible, onCancel, onConfirm, isLoading
export default function DeleteAccountModal({ visible, onCancel, onConfirm, isLoading }) {
  const modalWidth = useModalWidth();
  
  React.useEffect(() => { if (visible) scrollTriggerIntoView(); }, [visible]);

  return (
    <Modal
      centered
      open={visible}
      destroyOnClose={true}
      closable={false}
      footer={null}
      onCancel={onCancel}
      width={modalWidth}
      zIndex={4000}
    >
      <div className="p-5">
        <div className="delete-modal" style={{ textAlign: 'center' }}>
          {/* Danger triangle icon for stronger visual cue */}
          <i className="bi bi-exclamation-triangle-fill text-danger" style={{ fontSize: '4.5rem', marginBottom: 12 }} aria-hidden="true" />
          <p className="lead mt-2" style={{ fontWeight: 700, fontSize: 20, margin: '8px 0 8px 0' }}>Head Up!</p>
          <p className="text-black-50" style={{ color: '#555', marginBottom: 12 }}>Deleting your account will mean the following:</p>
          <ul style={{ textAlign: 'left', maxWidth: 520, margin: '0 auto 16px', color: '#444', paddingLeft: 18, lineHeight: '1.6' }}>
            <li style={{ marginBottom: 8 }}>You lose access to all your policies and journeys.</li>
            <li style={{ marginBottom: 8 }}>Your account will be temporarily deleted but will be permanently deleted after 30 days.</li>
            <li style={{ marginBottom: 8 }}>You lose access to funds kept with us.</li>
            <li style={{ marginBottom: 8 }}>You will not be able to recover your account.</li>
            <li style={{ marginBottom: 8 }}>Your resources will no longer be accessible.</li>
          </ul>

          <div className="delete-modal-buttons" style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <button className="btn btn-primary mb-4" onClick={onConfirm} disabled={isLoading} style={{ background: isLoading ? undefined : '#d93025', borderColor: isLoading ? undefined : '#d93025', color: '#fff', padding: '10px 20px' }}>{isLoading ? 'Processing...' : 'Proceed'}</button>
            <button className="btn btn-white mb-4" onClick={onCancel} style={{ padding: '10px 20px', fontWeight: 600 }}>Cancel</button>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .delete-modal {
            padding: 20px !important;
          }
          .delete-modal .bi-exclamation-triangle-fill {
            font-size: 3.5rem !important;
          }
          .delete-modal .lead {
            font-size: 18px !important;
          }
          .delete-modal ul {
            padding-left: 16px !important;
            max-width: 100% !important;
          }
          .delete-modal-buttons {
            flex-direction: column !important;
            align-items: center !important;
          }
          .delete-modal button {
            width: 100% !important;
            max-width: 280px !important;
            margin-bottom: 8px !important;
          }
        }
        @media (max-width: 480px) {
          .delete-modal {
            padding: 16px !important;
          }
          .delete-modal .bi-exclamation-triangle-fill {
            font-size: 3rem !important;
          }
          .delete-modal .lead {
            font-size: 16px !important;
          }
          .delete-modal ul {
            font-size: 14px !important;
            line-height: 1.5 !important;
          }
        }
      `}</style>
    </Modal>
  );
}